<div class="scope-chooser" data-testid="scope-chooser">
    <span class="scope-chooser__label">Auto-approve for</span>
    <wa-dropdown
        class="scope-chooser__dropdown"
        data-testid="scope-chooser-dropdown"
        placement="top-start"
        (wa-select)="onDropdownSelect($event)">
        <wa-button
            appearance="outlined"
            class="scope-chooser__trigger"
            data-testid="scope-chooser-trigger"
            size="s"
            slot="trigger"
            type="button"
            with-caret
            [disabled]="busy() || allLocked()">
            {{ selectedLabel() }}
        </wa-button>
        @for (rung of selectableRungs(); track rung.scope_tier) {
            <wa-dropdown-item [attr.value]="rung.scope_tier">{{ rung.label }}</wa-dropdown-item>
        }
    </wa-dropdown>

    <div class="scope-chooser__actions">
        <button class="scope-chooser__btn" data-testid="scope-chooser-cancel" type="button" [disabled]="busy()" (click)="onCancel()">
            Cancel
        </button>
        <button
            class="scope-chooser__btn scope-chooser__btn--primary"
            data-testid="scope-chooser-confirm"
            type="button"
            [disabled]="busy() || allLocked()"
            (click)="onConfirm()">
            {{ busy() ? 'Saving…' : confirmLabel() }}
        </button>
    </div>
</div>
